import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import i18n from '@/locale/i18n';
import { ref, watch } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'XDropdown',
  props: { 
    modelValue: {
        type: [String, Number],
        default: undefined
    },
    defalutValue: {
        type: [String, Number],
        default: undefined
    },
    enableDefaultValue: {
        type: Boolean,
        default: false
    },
    enableCustomizePanleStyle: {
        type: Boolean,
        default: false
    },
    placeholder: {
        type: String,
        default: undefined
    },
    inputClass: {
        type:String,
        default: undefined
    },
    heightSet: {
        type: Boolean,
        default: true
    }
},
  emits: ['update:modelValue', 'change', 'show', 'hide', 'click'],
  setup(__props, { emit: emits }) {

const props = __props

const t = i18n.global.t;
const displayPanle = ref(false);
const multiSelectIsHide = ref(false);
const isMouseClick = ref(false);
const dropdown = ref();

const dropdownIsChange = ref(false);
const modelValueTem = ref(props.modelValue);
const oldValue = ref();
const notMouseClick = ref(false);
const clickClear = ref(false);
const backspaceKey = ref(false);
watch(modelValueTem, (newVal, oldVal)=> {
    oldValue.value = oldVal!;
    emits('update:modelValue', newVal);
})
watch(() => props.modelValue, (newVal, oldVal)=> {
    modelValueTem.value = newVal;
}, {deep: true})


const listenerKey = (event: any) => {
    if (!props.enableCustomizePanleStyle) {
        return;
    }
    if (event.code === 'ArrowDown') {
        event.preventDefault();
    }
    if (event.altKey && event.code === 'ArrowDown') {
        displayPanle.value = true;
        if (dropdownIsChange.value) {
            modelValueTem.value = oldValue.value;
            emits('update:modelValue', oldValue.value);
            getOldValue({originalEvent: event,value: oldValue.value});
            dropdownIsChange.value = false;
        }
    }
    if (event.code === 'Backspace' && !displayPanle.value) {
        if (props.enableDefaultValue) {
            modelValueTem.value = props.defalutValue;
            emits('update:modelValue', props.defalutValue);
            getOldValue({originalEvent: event,value: props.defalutValue});
            clickClear.value = false;
        }
    }
 }

const mouseClick = (event: any) => {
    if (event.pointerType === 'mouse') {
        if (!displayPanle.value && dropdown.value === document.activeElement) {
            dropdown.value.$el.click();
        }
        if (!clickClear.value) {
            isMouseClick.value = true;
        }
        clickClear.value = false;
        notMouseClick.value = false;
    }
    if (event.pointerType !== 'mouse') {
        isMouseClick.value = false;
        notMouseClick.value = true;
    }
    emits('click', event);
}

const multiSelectPanelHide = (event: any) => {
    displayPanle.value = false;
    multiSelectIsHide.value = true;
    dropdownIsChange.value = false;
    isMouseClick.value = false;
    emits('hide', event);
 }

 const multiSelectPanelShow = (event: any) => {
    multiSelectIsHide.value = false;
    emits('show', event);
    if (notMouseClick.value && props.enableCustomizePanleStyle) {
        dropdown.value.$el.click();
        notMouseClick.value = false;
    }

 }

 const getOldValue = (event: any) => {
    dropdownIsChange.value = true;
    if (event.value === undefined || event.value === null) {
        event.value = props.defalutValue;
        clickClear.value = true;
    }
    modelValueTem.value = event.value;
    emits('update:modelValue', event.value);
    emits('change', event);
 }

return (_ctx: any,_cache: any) => {
  const _component_Dropdown = _resolveComponent("Dropdown")!

  return (_openBlock(), _createBlock(_component_Dropdown, {
    ref_key: "dropdown",
    ref: dropdown,
    modelValue: modelValueTem.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValueTem).value = $event)),
    class: _normalizeClass(__props.heightSet?'x1s-dropdown-height-font':'x1s-dropdown-font'),
    placeholder: __props.placeholder ? __props.placeholder : _unref(t)('COMMON.PLACEHOLDER_SELECT'),
    panelClass: __props.enableCustomizePanleStyle && !displayPanle.value && !isMouseClick.value ? 'global-multi-select-panel' : '',
    showClear: __props.enableDefaultValue && __props.defalutValue!==modelValueTem.value,
    onClick: mouseClick,
    onKeydown: listenerKey,
    onHide: multiSelectPanelHide,
    onShow: multiSelectPanelShow,
    onChange: getOldValue,
    inputClass: __props.inputClass
  }, {
    option: _withCtx((slotProps) => [
      _renderSlot(_ctx.$slots, "option", {
        option: slotProps.option
      })
    ]),
    value: _withCtx((slotProps) => [
      _renderSlot(_ctx.$slots, "value", {
        value: slotProps.value
      })
    ]),
    _: 3
  }, 8, ["modelValue", "class", "placeholder", "panelClass", "showClear", "inputClass"]))
}
}

})